import { Injectable } from '@angular/core';

export interface ToastInfo {
  header?: string;
  body?: string;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class AppToastService {
  toasts: ToastInfo[] = [];

  show(header: string, body: string) {
    this.toasts.push({ header, body });
  }
  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter(t => t != toast);
  }

  showSuccess(body: string, delay?: number) {
    this.toasts.push({ body, classname: 'bg-success text-light toast-success', delay: delay });
  }

  showError(body: string ) {
    this.toasts.push({ body, classname: 'bg-danger text-light toast-error' });
  }
}